import { Component } from '@angular/core';

@Component({
    selector: 'verification-required',
    templateUrl: './verification-required.component.html',
    styleUrls: ['./verification-required.component.less']
})
export class VerificationRequiredComponent {
    email = window.newUserEmail;

    constructor() {}

    goToMainSite(): void {
        window.location.href = "https://www.brixx.com";
    }
}